<template>
  <div class="dialog-wrap">

    <el-dialog title="分值管理"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="1300px">
      <div class="title-wrap">
        <div class="input-box">
          <span>试卷名称：</span>
          <p>{{paper.name}}</p>
        </div>
        <span>总分值：{{conputendSocre}}分</span>
      </div>
      <el-table class="table"
                max-height="600"
                :data="itemList"
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column prop="id"
                         align="center"
                         label="ID"
                         width="120">
        </el-table-column>
        <el-table-column label="题干"
                         min-width="180">
          <template slot-scope="scope">
            <div class="material"
                 v-if="scope.row.material">
              <span v-html="scope.row.rich_text"></span>
            </div>
            <div class="material"
                 v-if="!scope.row.material">
              <span v-html="scope.row.description"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="题型"
                         prop="answer_type_text"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="题目ID"
                         prop="item_id"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column abel="在线状态"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status===1">已上线</span>
            <span v-if="scope.row.status===0">已上线</span>
          </template>
        </el-table-column>
        <el-table-column label="分值"
                         align="center"
                         width="120">
          <template slot-scope="scope">
            <div v-if="!scope.row.material">
              <el-input v-model="scope.row.score"
                        placeholder="请输入分值"
                        @change="change(scope.row)"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop=""
                         align="center"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <div class="up-down"
                 v-if="!scope.row.material">
              <div v-if="itemIndex(scope.$index,scope.row)!=0">
                <el-button type="success"
                           @click="handleSortChange(scope.$index,scope.row,'up')"
                           icon="el-icon-top"
                           circle></el-button>
              </div>
              <div v-if="scope.$index!=(itemLength(scope.row,scope.$index)-1)">
                <el-button type="info"
                           @click="handleSortChange(scope.$index,scope.row,'down')"
                           icon="el-icon-bottom"
                           circle></el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  examPaperItemUpdate,
  examPaperItemsUpdate,
  examPaperItemList,
  examPaperOne,
} from '@/api/exam'
let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    paperId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      itemList: [],
      paper: {},
    }
  },
  computed: {
    conputendSocre() {
      let score = 0
      this.itemList.forEach((item, index) => {
        if (!item.children) {
          score += Number(item.score || 0)
        }
        if (item.children) {
          item.children.forEach((subItem) => {
            score += Number(subItem.score || 0)
          })
        }
      })
      return score
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchPaperInfo()
        this.fetchPaperItemList()
      }
    },
  },
  created() {},
  methods: {
    // 题库基本信息
    fetchPaperInfo() {
      if (!this.paperId) {
        return
      }
      examPaperOne({ id: this.paperId }).then((res) => {
        if (res) {
          this.paper = res
        }
      })
    },
    //试卷题目列表
    fetchPaperItemList() {
      if (!this.paperId) {
        return
      }
      examPaperItemList({ paper_id: this.paperId }).then((res) => {
        this.itemList = res.list || []
        console.log('itemList', this.itemList)
      })
    },
    change(val) {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        examPaperItemUpdate({ id: val.id, score: val.score }).then((res) => {})
      }, TimerTime)
    },
    itemIndex(index, row) {
      let material = 0
      this.itemList.forEach((item, index) => {
        if (item.children) {
          material = 1
        } else {
          material = 0
        }
      })
      if (material) {
        index = index - 1
      } else {
        index = index
      }
      return index
    },
    itemLength(row, index) {
      let material = 0
      let itemLength = 0
      this.itemList.forEach((item, subIndex) => {
        if (item.children) {
          material = 1
        } else {
          material = 0
        }
      })
      console.log('material', material)
      if (!material) {
        itemLength = this.itemList.length
      }
      if (material) {
        itemLength = this.itemList[0].children.length + 1
      }
      return itemLength
    },
    handleClose() {
      this.$emit('close')
    },
    handleSortChange(index, item, type) {
      let itemIndex = 0
      let material = 0
      this.itemList.forEach((fatherItem, fatherIndex) => {
        if (fatherItem.children) {
          fatherItem.children.forEach((subItem, subIndex) => {
            if (subItem.id == item.id) {
              itemIndex = fatherIndex
              material = 1
            }
          })
        } else {
          material = 0
        }
      })
      if (material) {
        let old = this.itemList[itemIndex].children.splice(index - 1, 1)[0]
        if (type == 'up') {
          this.itemList[itemIndex].children.splice(index - 1 - 1, 0, old)
        } else if (type == 'down') {
          this.itemList[itemIndex].children.splice(index, 0, old)
        }
        const rows = this.itemList[itemIndex].children.map((item, sort) => {
          return { id: item.id, sort: sort }
        })
        examPaperItemsUpdate(rows)
          .then((res) => {})
          .catch((error) => {
            this.$message.error('题目排序更新异常')
            console.log('error: ', error)
          })
      }
      if (!material) {
        let old = this.itemList.splice(index, 1)[0]
        if (type == 'up') {
          this.itemList.splice(index - 1, 0, old)
        } else if (type == 'down') {
          this.itemList.splice(index + 1, 0, old)
        }
        const rows = this.itemList.map((item, sort) => {
          return { id: item.id, sort: sort }
        })
        examPaperItemsUpdate(rows)
          .then((res) => {})
          .catch((error) => {
            this.$message.error('题目排序更新异常')
            console.log('error: ', error)
          })
      }
    },
    handleExanEdit(index, item) {},
  },
}
</script>

<style scoped lang="less">
.dialog-wrap {
  .table {
    margin-top: 10px;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .material {
    max-height: 40px;
    overflow: hidden;
    overflow-y: auto;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .input-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    .el-input {
      width: 400px;
    }
  }
  .title-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .up-down {
    padding: 0 20px;
    justify-content: space-around;
    display: flex;
    flex-direction: row;
  }
}
</style>
